import React from 'react';

export const msgList = ({ msg }) => {
  return (
    
      
        <div key={msg.id} className="mb- border-b">
          <div className="flex items-center mb-4">
            <img
              src={msg.avatar}
              alt={msg.name}
              className="w-2 h-10 rounded-full mr-4"
            />
            <div>
              <div className='flex justify-between items-center'>
                <h3 className="text-lg font-bold">{msg.name}</h3>
                <p className="text-sm text-[#6B7280]">{msg.date}</p>
             </div>
              <p className="text-sm text-[#4A5568]">{msg.company}</p>
            </div>
          </div>  
     </div>
  );
};

export default msgList;
